module.exports = __webpack_public_path__ + "static/death_taxes-54eef423c70f6acc9ea064f079cb7ba1.webp";